import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import HowItWorks from "./pages/HowItWorks";
import Pricing from "./pages/Pricing";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import Checkout from "./pages/Checkout";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import LiveTicker from "./components/LiveTicker";
import StickyBookCTA from "./components/StickyBookCTA";
import SirKnightChat from "./components/SirKnightChat";
import ScrollProgress from "./components/ScrollProgress";
import PageTransition from "./components/PageTransition";
import CustomCursor from "./components/CustomCursor";
import FollowInstagram from "./components/FollowInstagram";
import FloatingConsultCTA from "./components/FloatingConsultCTA";
import { Toaster } from "./components/ui/toaster";
import { CartProvider } from "./contexts/CartContext";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Wait for the target page/section to render, then smooth-scroll to it.
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        else window.scrollTo({ top: 0, behavior: "instant" });
      }, 350);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

const CardGlowTracker = () => {
  useEffect(() => {
    const handler = (e) => {
      const card = e.target.closest(".card-intense");
      if (!card) return;
      const rect = card.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      card.style.setProperty("--mx", `${x}%`);
      card.style.setProperty("--my", `${y}%`);
    };
    document.addEventListener("mousemove", handler);
    return () => document.removeEventListener("mousemove", handler);
  }, []);
  return null;
};

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ScrollProgress />
          <ScrollToTop />
          <CardGlowTracker />
          <Navbar />
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/terms-of-service" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </PageTransition>
          <Footer />
          <LiveTicker />
          <StickyBookCTA />
          <SirKnightChat />
          <CustomCursor />
          <FollowInstagram />
          <FloatingConsultCTA />
          <Toaster />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
